import { render, staticRenderFns } from "./Analitica.vue?vue&type=template&id=1925c143&scoped=true&"
var script = {}
import style0 from "./analitica.scss?vue&type=style&index=0&id=1925c143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925c143",
  null
  
)

export default component.exports